<template lang="pug">
    v-dialog(v-model="sentEmailDialog" max-width="500px")
        v-card
            .text-xs-right
                v-btn(
                    icon
                    @click="close()"
                )
                    v-icon mdi-close
            v-card-text
                Loader(:loading="loading")
                    div(slot="loadingMsg"
                    class="full-width text-xs-center headline my-2"
                    ) Sending Authorization Link...
                Success( v-if="authorizationLinkSent"
                    :src="successPlane"
                    :sentTo="email"
                )
                Resend(
                    v-if="resendLink"
                    :sentTo="email"
                    @resend="resend()" 
                )
                div(
                    v-else
                    v-html="authorizationLinkMessaging"
                )
     
</template>

<script>
    import { mapActions, } from 'vuex'
    import Loader from 'Components/FanLoader.vue'
    import Resend from 'Components/EasyLinkDialog/Resend'
    import Success from 'Components/EasyLinkDialog/Success'

    export default {
        name: 'authorization-link-dialog',
        props: {
            sentEmailDialog: {
                type: Boolean
            },
            loading: {
                type: Boolean
            },
            authorizationLinkSent: {
                type: Boolean
            },
            resendLink: {
                type: Boolean
            },
            email: {
                type: String
            },
            authorizationLinkMessaging: {
                type: String
            }

        }, 
        data: () => ({
            successPlane: require('@/assets/success-plane.svg'),
        }),
        components: {
            Loader,
            Resend,
            Success
        },
        methods: {
            ...mapActions([
                'resendEasyLink',
            ]),
            close() {
                this.$emit('close')
            },
            resend() {
                this.$emit('resend')
            }
        }
    }
</script>